export const CHANGE_SOCKET_STATUS = "CHANGE_SOCKET_STATUS";

export const changeSocketStatus = (status) => {
    return { type: CHANGE_SOCKET_STATUS, payload: status };
};
